import React, { useState, useEffect } from 'react';
import {
  IonButton,
  IonRow,
  IonCol,
  isPlatform,
  IonModal,
  IonCard,
  IonCardHeader,
  IonCardContent,
  IonCheckbox,
  IonLabel,
  IonItem,
  IonList,
  IonRadio,
  IonRadioGroup,
  IonInput
} from '@ionic/react';
import { useAuthService } from '../../services/Auth';
import './Login.page.scss';
import { useNetwork } from '../../utils/useNetwork';
import { NA, KEYS, ENV, ENABLE_R2_FEATURE, ICON_PATH } from '../../utils/constants';
import { getApplicationInfoBeforeLogin, logEvent, setScreenName } from '../../utils/Analytics';
import { R2Configuration } from '../../utils/common';
import i18n from '../../../i18n';
import { EVENT, SCREEN } from '../../utils/constants.analytics';
import AppUpdate from '../../components/AppUpdate';
import { OneTrustConfigSetupPopUp } from './OneTrustConfig/OneTrustConfig.page';

const LoginContainer: any = (props: any) => {
  const { getNetworkStatus, networkStatus } = useNetwork();
  const [openModal, getOpenModal] = useState(false);
  const [showR2ConfigurationModal, setShowR2ConfigurationModal] = useState(false);
  const authService = useAuthService();

  useEffect(() => {
    setScreenName("screen_login_container");
    getApplicationInfoBeforeLogin().then(res => {
      logEvent(EVENT.SV_GET_STARTED, {
        screen: SCREEN.GET_STARTED,
        channel: res.channel,
        os: res.os,
        device_name: res.device_name,
        model: res.model,
        sessionId: NA,
        userId: NA,
        carrierId: NA
      });
    });
  }, []);

  const tryAction = async (fn: () => Promise<any>, defaultError: string) => {
    getNetworkStatus();
    logEvent(EVENT.UE_SIGN_IN, { screen: SCREEN.GET_STARTED, sessionId: NA });
    if (networkStatus.connected === false) {
      getOpenModal(true);
    }
    try {
      await fn();
    } catch (err) {
      console.error(err);
    }
  };
  const onClickR2Configuration = (): void => {
    if (KEYS.RELEASE !== ENV.PROD) {
      setShowR2ConfigurationModal(true);
    }
  };

  return (
    <>
      <AppUpdate getOpenModal={getOpenModal} />
      {openModal ? (
        <div>
          <div className="networkError_div"></div>
          <div className="popup">
            <p className="no-network">{i18n.t('NO_NETWORK_TITLE')}</p>
            <p className="network-content">{i18n.t('NO_NETWORK_TEXT')}</p>
            <IonButton className="retry_button" onClick={() => getOpenModal(false)}>
              {i18n.t('Ok_TEXT')}
            </IonButton>
          </div>
        </div>
      ) : null}
      <div className="Landing-screen-content">
        {isPlatform('mobile') ? (
          <div className="globe-image" onClick={onClickR2Configuration}>
            <img src="assets/icon/app-landing.svg" alt="FreightPower App landing image " />
          </div>
        ) : (
            <>
              <div className="globe-image">
                <p className="getStarted" data-testid="Get-Started">
                  {i18n.t('GET_STARTED_TEXT')}
                </p>
                <p className="StartwithSignin" data-testid="Start-With">
                  {i18n.t('SIGNUP_TEXT')}
                </p>
                <img src={ICON_PATH.mid_icon} className="midpart-icon" alt="" />
              </div>
            </>
          )}
        <div className="signup-buttons">
          <IonRow>
            <IonCol
              data-test="SignIn-btn"
              className="signIn-col"
              onClick={() => {
                tryAction(authService.login.bind(authService), i18n.t('There was an error logging in'));
              }}>
              <IonButton class="load-btn-Signup" data-test="signin-button">
                <span className="signup-btn">{i18n.t('GET_STARTED_TEXT')}</span>
              </IonButton>
            </IonCol>
          </IonRow>
        </div>
      </div>
      {/* OneTrust Config Setup PopUp */}
      { /* <OneTrustConfigSetupPopUp
      showModal = {showR2ConfigurationModal}
      authService = {props.authService}
      closeShowModal={(props: any) => {
        setShowR2ConfigurationModal(false);
      }}
      /> */}
    </>
  );
};

export default LoginContainer;
